/** Sorted list of nationality adjective forms used throughout the app. */
export const NATIONALITIES: string[] = [
  "Afghan", "Albanian", "Algerian", "American", "Andorran", "Angolan", "Argentine",
  "Australian", "Austrian", "Azerbaijani", "Bahraini", "Barbadian", "Belarusian",
  "Belgian", "Bosnian", "Brazilian", "British", "Bulgarian", "Burundian", "Cameroonian",
  "Canadian", "Chadian", "Chilean", "Chinese", "Colombian", "Congolese", "Croatian",
  "Cuban", "Cypriot", "Czech", "Danish", "Dutch", "Ecuadorian", "Egyptian", "English",
  "Estonian", "Ethiopian", "Faroese", "Finnish", "French", "Gabonese", "Gambian",
  "Georgian", "German", "Ghanaian", "Greek", "Guatemalan", "Guinean", "Haitian",
  "Honduran", "Hungarian", "Icelandic", "Indian", "Indonesian", "Iranian", "Iraqi",
  "Irish", "Israeli", "Italian", "Ivorian", "Jamaican", "Japanese", "Jordanian",
  "Kenyan", "Korean", "Kosovar", "Kuwaiti", "Latvian", "Lebanese", "Libyan",
  "Lithuanian", "Luxembourgish", "Macedonian", "Madagascan", "Malaysian", "Malian",
  "Maltese", "Mauritanian", "Mexican", "Moldovan", "Montenegrin", "Moroccan",
  "Mozambican", "Namibian", "Nigerian", "Norwegian", "Omani", "Pakistani", "Palestinian",
  "Paraguayan", "Peruvian", "Philippine", "Polish", "Portuguese", "Qatari", "Romanian",
  "Russian", "Rwandan", "Scottish", "Senegalese", "Serbian", "Slovak", "Slovenian",
  "Somalian", "Spanish", "Sudanese", "Swedish", "Swiss", "Syrian", "Tanzanian", "Thai",
  "Togolese", "Trinidadian", "Tunisian", "Turkish", "Ugandan", "Ukrainian", "Uruguayan",
  "Uzbek", "Venezuelan", "Vietnamese", "Welsh", "Zambian", "Zimbabwean",
];
